import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { usePmsEquipmentSystem, PmsEquipmentSystem } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => (
  <GenericFormPage<PmsEquipmentSystem>
    useData={usePmsEquipmentSystem}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
    }}
  />
);

export default Form;
